exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal[data-v-0ec8cf79]{height:auto;width:30%;position:fixed;z-index:1;top:100px;right:50px;padding:20px;background-color:#f44336;color:#fff;border-radius:5px}.closebtn[data-v-0ec8cf79]{margin-left:15px;color:#fff;font-weight:700;float:right;font-size:22px;line-height:20px;cursor:pointer;transition:.3s}.closebtn[data-v-0ec8cf79]:hover{color:#000}", ""]);

// exports
